import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import PageHeaderSmall from "../../components/PageHeaderSmall";
import BlogImage from "../../components/BlogImage";

const SmartThermo = () => {
  const { closeNavbarMenu } = useNavContext();
  const title = "Do Smart Thermostats Save Money?";
  const imgOne =
    "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_700/v1643280254/AquaHeat/Navbar%20Images/smartstat2_ayouwd.webp";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} />
      <BlogImage img={imgOne} onMouseOver={closeNavbarMenu} />
      <section
        className="section-wrapper conditions_global"
        onMouseOver={closeNavbarMenu}
      >
        <div className="conditions_body">
          <h2 className="conditions_subtitle">
            Smart tech is a smart move for cutting your energy bill
          </h2>
          <p className="conditions_paragraph">
            Have you been thinking about getting a smart thermostat? But not
            sure if you should make the switch. Not only does smart tech bring
            cool features to your home, it can help you save energy and money.
            The EPA reports that you could save roughly $180 a year by using a
            programmable thermostat. And it’s even easier with a smart
            thermostat that does all the thinking for you.
          </p>
          <p className="conditions_paragraph">
            Here’s how the savings adds up. If you set your thermostat 1 or 2
            degrees higher or lower than your usual number, you’ll see a 1 to 3
            percent savings in your energy bill. Take it to the next level by
            setting it back 10 to 15 degrees for the 8 hours you’re at work and
            your savings jumps to nearly 10 percent.
          </p>
          <p className="conditions_paragraph">
            Of course, you can adjust your settings manually with a traditional
            programmable thermostat. The problem is most people forget to
            actually do it. One study discovered that nearly 50% of households
            with programmable thermostats don’t set them up. Enter the smart
            thermostat. It never forgets, learns your habits and actually cares
            about saving you money.
          </p>
          <h2 className="conditions_subtitle">
            3 Ways Smart Thermostats Help You Save Money
          </h2>
          <p className="conditions_paragraph">
            You initially program your ideal temperatures and settings. Then
            over time, your thermostat will observe your behavior and learn when
            you come and go, as well as what temperatures you prefer at certain
            times of the day. Your system can automatically adjust your settings
            to make sure your home is the perfect temp when you get home. Some
            thermostats even make adjustments based on humidity levels.
          </p>
          <p className="conditions_paragraph">
            Two-way communicating smart thermostats are always monitoring your
            usage, collecting data and sharing it with you 24/7. Their remote
            interfaces show how much energy you’re using and can even estimate
            your costs. From there you can make manual adjustments to your
            program or let your thermostat handle it. The magic lies in the
            data. The more you know, the easier it is to tweak your temps and
            see how it affects your energy bill. Smart thermostats give you the
            information you need to make smart decisions to improve your
            energy-efficiency and savings.
          </p>
          <p className="conditions_paragraph">
            Most systems will switch to an eco setting when you’re not at home,
            so you’ll automatically be saving energy. The thermostat does this
            with sensors that know when someone is at home or when everyone has
            left and there’s no movement in the house. They may also use
            geo-tracking to know when your phone is out of range of your home,
            signaling your system that it’s okay to go into eco mode. When
            you’re away longer, like for vacation, you can turn your system off
            and your smart tech will only turn it on if temperatures get
            dangerously high or low, preventing emergencies like frozen water
            pipes.
          </p>
        </div>
      </section>
    </>
  );
};

export default SmartThermo;
